<template>
  <div>
    <div class="app-container info-container pt32">
      <!--      <Basic class="mb72" :basic="basicData" :other="otherData" />-->
      <Certificate class="mb72" :certificate="certificateData" />
      <Other :other="otherData" />
    </div>
  </div>
</template>

<script>
// 用户信息
import { personInfo } from '@/api/me'
// import Basic from '@/views/MeInfo/components/Basic'
import Certificate from '@/views/MeInfo/components/Certificate'
import Other from '@/views/MeInfo/components/Other'
export default {
  name: 'MeInfo',
  components: {
    // Basic,
    Certificate,
    Other
  },
  data () {
    return {
      // basicData: {
      //   birthDay: '',
      //   nameEN: '',
      //   nameTH: ''
      // },
      certificateData: {},
      otherData: {}
    }
  },
  created () {
    this.personInfo()
  },
  mounted () {},
  methods: {
    personInfo () {
      personInfo().then(({ basic, certificate, other }) => {
        // this.personInfoData = data
        // this.basicData = basic
        this.certificateData = certificate
        this.otherData = other
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable selector-pseudo-element-no-unknown */
.info-container {
  padding-bottom: 95px;

  ::v-deep .flash-block-title {
    color: #333;
    font-size: 28px;
  }

  ::v-deep .flash-block__content {
    border-radius: 32px;
  }

  ::v-deep .md-field {
    padding-top: 4px;
    padding-bottom: 0;
    min-height: auto;
    border-radius: 32px;

    .md-field-item-content {
      align-items: start;
    }

    .md-field-item:last-child {
      .md-field-item-content::before {
        display: none;
      }
    }

    .md-field-item-right {
      color: #333;
      width: 150px;
      word-wrap: break-word;
      word-break: break-all;
    }

    .md-field-item-title {
      color: #7f7f7f;
    }
  }
  /* stylelint-enable */
}
</style>
